"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Warning = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var core_1 = require("@material-ui/core");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    box: {
        color: '#742300',
        border: '1px solid #c54813',
        padding: theme.spacing(2) + "px " + theme.spacing(2) + "px " + theme.spacing(2) + "px " + theme.spacing(7) + "px",
        borderRadius: 8,
        fontSize: 16,
        background: '#fff8f3',
        position: 'relative',
        width: '100%',
        textAlign: 'left',
        '& a': {
            textDecoration: 'underline',
        },
    },
    icon: {
        fontSize: 24,
        verticalAlign: 'middle',
        position: 'absolute',
        left: theme.spacing(2),
        top: '50%',
        transform: 'translateY(-50%)',
    },
    emptyIcon: {},
}); });
var Warning = function (props) {
    var classes = useStyles(props);
    return (react_1.default.createElement(core_1.Box, { className: classes.box },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: props.icon ? props.icon : pro_light_svg_icons_1.faCircle, className: classes.icon }),
        react_1.default.createElement(Typography_1.default, null, props.children)));
};
exports.Warning = Warning;
